import { Pipe, PipeTransform } from '@angular/core';
import { ThemeType } from '@activia/ngx-components';

/**
 * This pipe returns the theme to apply based on the current value
 * e.g. for system memory:
 * - if value <= 70 return Success theme
 * - if value > 70 and <= 90 return Warning theme
 * - if value > 90 return Danger theme
 */
@Pipe({ name: 'thresholdTheme' })
export class ThresholdThemePipe implements PipeTransform {
  transform(value: number, thresholds: Array<{ ceilingValue: number; color: ThemeType }>): ThemeType {
    if (value == null || (thresholds || []).length === 0) {
      return null;
    }

    // start with the highest threshold value and compare. if no threshold match, use the default theme
    return [...thresholds].reverse().find((threshold) => !threshold.ceilingValue || threshold.ceilingValue < value)?.color;
  }
}
